/**
 * @generated SignedSource<<1368b0b409d3b4858b236476e5d18426>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RSVPToAllProductEventsButtonQuery$variables = {
  id: string;
};
export type RSVPToAllProductEventsButtonQuery$data = {
  readonly product: {
    readonly eventOccurrences?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly atCapacity: boolean;
          readonly hasViewerRSVPd: boolean;
          readonly id: string;
          readonly isComplete: boolean;
        };
      }>;
    } | null;
    readonly id?: string;
    readonly viewerMembership?: {
      readonly id: string;
    } | null;
  } | null;
};
export type RSVPToAllProductEventsButtonQuery = {
  response: RSVPToAllProductEventsButtonQuery$data;
  variables: RSVPToAllProductEventsButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductMembership",
  "kind": "LinkedField",
  "name": "viewerMembership",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "OccurrenceNodeConnection",
  "kind": "LinkedField",
  "name": "eventOccurrences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OccurrenceNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Occurrence",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasViewerRSVPd",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "atCapacity",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RSVPToAllProductEventsButtonQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RSVPToAllProductEventsButtonQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e57472805ab40769831125cf839d4fc1",
    "id": null,
    "metadata": {},
    "name": "RSVPToAllProductEventsButtonQuery",
    "operationKind": "query",
    "text": "query RSVPToAllProductEventsButtonQuery(\n  $id: ID!\n) {\n  product: node(id: $id) {\n    __typename\n    ... on Product {\n      id\n      viewerMembership {\n        id\n      }\n      eventOccurrences {\n        edges {\n          node {\n            id\n            isComplete\n            hasViewerRSVPd\n            atCapacity\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc814f1fb1a832a83cd252c0690b25ea";

export default node;
